import notify from 'devextreme/ui/notify';

export const NotifySuccess = ({
  message = 'Success!',
  displayTime = 7500,
  width = 450,
  outletContainer = '#outlet',
  position = { my: 'center top', at: 'center top', of: outletContainer },
} = {}) => {
  notify({
    message: message,
    type: 'success',
    displayTime: displayTime,
    position: position,
    width: width,
  });
};